import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { removeNote, saveNotesToStorage } from '../../../models/NoteModel';
import { apiError } from '../../../helpers/ErrorHelper';
import { useAuth } from '../../../context/AuthContext';
import { useNotificationCount } from '../../../context/NotificationCountContext';


const DeleteNoteModal = ({showModal, setShowModal, noteData, modalKey, fetchNotes, limit, page}) => {

  const { notificationCount, setNotificationCount } = useNotificationCount();

  const navigate = useNavigate();

    const { state } = useAuth(); 

    let user_data = state.user_data;
    
    const loader = document.getElementById('loading');

    const [loading, setLoading] = useState(false);
    
    const [_note_id, setNoteID] = useState('');

    const closeModal = () =>{
        setNoteID('');
        setShowModal(false);
    }

    useEffect(() => {
        // This effect will be called whenever noteData changes
        if (noteData) {
          setNoteID(noteData._note_id);
        }
    }, [noteData, modalKey]);


    const deleteNote = async() => {
        // Start the loading state
        loader.style.display = 'block';
    
        try {
          const response = await removeNote(user_data.user_token, _note_id);
    
          if (response.status) {
            toast.success(response.message);
    
            closeModal();
    
            saveNotesToStorage(response.data.notes, response.data.pagination);
    
            fetchNotes(limit, page); 

            setNotificationCount(localStorage.getItem('unread_notification_count'));
          }
          else{
            toast.error(response.message);
          }  
    
        } catch (error) {
          apiError(error);

          if (error.response.data.invalid_token==1) {
            navigate('/re-login');
          }
        }
    
        // Stop the loading state
        loader.style.display = 'none';
    }

    return (
        <Modal show={showModal} onHide={closeModal}>
            <Modal.Header closeButton>
                <Modal.Title>Delete Note</Modal.Title>
            </Modal.Header>
    
            <Modal.Body>
                <p>Do you want to delete this note ? This process can't be undone</p>
            </Modal.Body>
    
            <Modal.Footer>
                <button type="button" className="btn btn-light" onClick={closeModal}>Cancel</button>
                <button type="button" className="btn btn-danger" onClick={deleteNote}>Delete</button>
            </Modal.Footer>
        </Modal>
    );  

}; 


export default DeleteNoteModal;